import { sendRequest, sendRequestProtocols } from "../axios";

export default {
  state: {},
  mutations: {},
  actions: {
    async setIgnoreWinnersList(state, obj) {
      const fd = new FormData();
      fd.append("data", JSON.stringify(obj));
      const { data } = await sendRequest("ignoreWinnersList", "post", fd);
      return data;
    },
    async setIgnoreWinner(state, obj) {
      const { data } = await sendRequest(`ignoreWinners`, "post", obj);
      return data;
    },
    async getIgnoreWinnerList(state) {
      const { data } = await sendRequest(`ignoreWinnersList`, "get");
      return data;
    },
    async getIgnoreWinners({ commit }, obj) {
      const fd = new FormData();
      fd.append("user_id", obj.user_id);
      fd.append("page", obj.pagination.page);
      fd.append("itemsPerPage", obj.pagination.itemsPerPage);
      fd.append("sortBy", obj.pagination.sortBy[0]);
      fd.append("sortDesc", obj.pagination.sortDesc[0]);
      const { data } = await sendRequest(
        `ignoreWinners/${obj.user_id}`,
        "post",
        fd
      );
      return data;
    },

    async removeIgnoreWinner({ commit }, obj) {
      const { data } = await sendRequest(
        `ignoreWinners/${obj.id}`,
        "delete"
      );
      return data;
    }

  },
  getters: {
    // getRegionRe: (state) =>state.regions_re,
  }
};
